import { TextInput } from "components/core";
import { FormikProps } from "formik";
import _ from "lodash";
import moment from "moment";
import { FC } from "react";

export interface ProfitStatementCommisionFormProps {
  form: FormikProps<any>;
  type?: "reinsurer" | "broker";
}

const ProfitStatementCommisionForm: FC<ProfitStatementCommisionFormProps> = ({
  form,
  type = "reinsurer",
}) => {
  return (
    <div className="space-y-6 divide-y divide-gray-200">
      <div>
        <div className="grid grid-cols-2 gap-2">
          <div className="col-span-3">
            <div className="">
              <div className="grid grid-cols-3 gap-6 mt-2">
                <div className="col-span-3">
                  <TextInput
                    id={"overall_gross_premium"}
                    type="number"
                    label={`100% Gross Premium Ceded To Reinsurers - ${moment().format("YYYY")}`}
                    required
                    placeholder="100% Gross Premium"
                    {...form}
                  />
                </div>
                <div className="col-span-3">
                  <TextInput
                    id={"losses"}
                    type="number"
                    label="Losses outstanding"
                    required
                    placeholder="Losses outstanding"
                    {...form}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-3 mt-6">
            <div className="">
              <h2 className="font-medium text-lg">
                Losses recorded in the previous year{" "}
              </h2>
              <div className="grid grid-cols-2 gap-6 mt-2">
                <div className="">
                  <TextInput
                    id={"prev_year_configuration.outgoing_premium_portfolio"}
                    type="number"
                    label="Outgoing Premium Portfolio"
                    required
                    placeholder="Outgoing Premium Portfolio"
                    {...form}
                  />
                </div>
                <div className="">
                  <TextInput
                    id={"prev_year_configuration.outgoing_loss_portfolio"}
                    type="number"
                    label="Outgoing Loss Portfolio"
                    required
                    placeholder="Outgoing Loss Portfolio"
                    {...form}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-3 mt-6">
            <div className="">
              <h2 className="font-medium text-lg">
                Losses recorded in the previous year{" "}
              </h2>
              <div className="grid grid-cols-2 gap-6 mt-2">
                <div className="">
                  <TextInput
                    id={"known_losses.loss"}
                    type="number"
                    label="Losses Recorded"
                    required
                    placeholder="Losses Recorded"
                    {...form}
                  />
                </div>
                <div className="">
                  <TextInput
                    id={"known_losses.date"}
                    type="date"
                    label="Losses Recorded as at"
                    required
                    placeholder="Losses Recorded as at"
                    {...form}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitStatementCommisionForm;
